import { TrainingInsightFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useTrainedEmployeesByGender = (insights: TrainingInsightFragment) => {
  const trainedEmployeesByGender = insights.trainedEmployeesByGender
    ? insights.trainedEmployeesByGender.map((value, index) => {
        let gender: string | undefined = value.gender === 'male' ? i18n.t('common.male') : undefined
        gender = value.gender === 'female' ? i18n.t('common.female') : gender

        gender = gender || i18n.t('trainings.insights.charts.employees_gender.no_gender')
        return {
          id: index,
          originalLabel: gender,
          label: gender,
          value: value.employeeCount,
        }
      })
    : []

  return { trainedEmployeesByGender }
}
